<div class="filter-sidebar" [class.filter-sidebar--open]="isOpen()">
  <div class="filter-sidebar__header">
    <h3 class="filter-sidebar__title">{{ 'orders.filters.title' | translate }}</h3>
    <button mat-icon-button class="filter-sidebar__close-btn" (click)="closePanel.emit()">
      <mat-icon class="filter-sidebar__close-icon">close</mat-icon>
    </button>
  </div>

  <div class="filter-sidebar__content">
    <app-table-sort [(activeSortKey)]="filterSortKey" (sortChanged)="handleSortChanged($event)" />

    <div class="filter-sections-container">
      @let config = filterConfig;
      @for (section of config; track section.key) {
        <div class="filter-section">
          <div class="filter-section-title">
            {{ section.title | translate }}
          </div>
          @let sectionOptions = filterOptions[section.key]();

          @if (section.key === orderFilterSections.DATE_CREATED) {
            <app-date-range-filter
              [dateRangeOptions]="sectionOptions"
              [externalSelectedOption]="selectedFilters()[section.key][0]"
              (toggleFilterOptions)="
                toggleOption({ section: section.key, dateRangeSelection: $event })
              "
            />
          } @else {
            @for (option of sectionOptions; track option.key) {
              @let selectedSectionOptions = selectedFilters()[section.key];
              <mat-checkbox
                [checked]="selectedSectionOptions.includes(option.key)"
                (change)="
                  toggleOption({
                    section: section.key,
                    option: option.key,
                    checked: $event.checked,
                  })
                "
              >
                {{ option.label | translate }}
              </mat-checkbox>
            }
          }
        </div>
      }
    </div>
  </div>

  <div class="filter-sidebar__footer">
    <button mat-button class="btn-clear" (click)="resetFilters()">
      {{ 'orders.filters.buttons.resetAll' | translate }}
    </button>
    <button mat-flat-button class="btn-apply" (click)="applyFilters()">
      {{ 'orders.filters.buttons.showResult' | translate }}
    </button>
  </div>
</div>

@if (isOpen()) {
  <button
    class="filter-sidebar-backdrop"
    (click)="closePanel.emit()"
    aria-label="Close filter panel"
  ></button>
}
